import {
    COMPETITION_SECRETARY_POST_FAILURE,
    COMPETITION_SECRETARY_POST_SUCCESS,
    COMPETITION_SECRETARY_POST_REQUEST,
} from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
};

export const competitionSecretaryPostReducer = (state = initialState, action) => {
    const {type, competition} = action;

    switch (type) {
        case COMPETITION_SECRETARY_POST_SUCCESS: {return {
            ...initialState,
            competition,
        }}

        case COMPETITION_SECRETARY_POST_REQUEST: {return {
            ...initialState,
            posting: true,
        }}

        case COMPETITION_SECRETARY_POST_FAILURE: {return {
            ...initialState,
            posting: false,
            hasErrors: true,
        }}

        default: {return state}
    }
};
